import CoursesSearch from './courses-search'
import Courses from './courses'
import { useMetadata } from 'hooks/useMetadata'; // Import the hook

export default function PageSearch() {
  useMetadata({
    page: 'search'
  });

  return (
    <>
      <Courses />
      <CoursesSearch />
    </>
  )
}